// Worklist: the routes and the sidebar rows of `wealth.platform.tasks` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.platform.tasks',
    routes: [
        { frontend: 'desk', path: 'actions', lazy: () => import('@/pages/desk/actions/page') },
    ],
    nav: [
        // The worklist. It has no sidebar row, but the "Open actions" figure on
        // My Book opens it, so the route stays open (`sidebarHidden`).
        {
            frontend: 'desk',
            key: 'actions',
            label: 'Actions',
            href: '/desk/actions',
            icon: 'CheckSquare',
            group: 'tasks-alerts',
            order: 2130,
            sidebarHidden: true,
        },
    ],
});
